var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import getTranslationForTransactionDisputeReasonDocs from '../../../../helpers/getTranslationForTransactionDisputeReasonDocs';
import { Trans } from 'react-i18next';
import i18n, { t } from '../../../../strings/i18n/i18n';
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import theme from '../../../../theme';
var DocsRequestedContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: ", "px;\n  font-size: 14px;\n"], ["\n  background-color: ", ";\n  padding: ", "px;\n  font-size: 14px;\n"])), theme.colors.greyNinetyEight, spacing.base);
var DocumentsRequested = function (_a) {
    var disputeReason = _a.disputeReason;
    var disputeReasonTranslationKey = getTranslationForTransactionDisputeReasonDocs(disputeReason);
    if (!disputeReasonTranslationKey) {
        return null;
    }
    var disputeReasonTranslation = t(disputeReasonTranslationKey);
    return (_jsx(DocsRequestedContainer, __assign({ "data-cy": "recommended-documentation-section" }, { children: _jsx(Trans, { i18n: i18n, i18nKey: "disputeDetails.recommendedDocumentation", tOptions: {
                disputeReason: disputeReasonTranslation
            }, components: [
                _jsx("b", { "data-testid": "bold-text" }, "required-documentation")
            ] }) })));
};
export default DocumentsRequested;
var templateObject_1;
//# sourceMappingURL=index.js.map